/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ApprovePage} from './components/ApprovePage'
import {ResetPage} from './components/ResetPage'
import {RegisterPassive} from './components/RegisterPassive'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Languages} from '../../../_metronic/partials/layout/header-menus/Languages'
import {EmailVerification} from './components/EmailVerification'

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid position-x-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl(
          '/media/illustrations/sketchy-1/unipabackground.jpeg'
        )})`,
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/tinaztepe.png')}
            style={{height: '210px', width: 'auto'}}
          />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <div
            className='menu menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
            data-kt-menu='true'
          >
            <Languages languageMenuPlacement='bottom' />
          </div>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='registration' element={<Registration />} />
      <Route path='registerpassive' element={<RegisterPassive />} />
      <Route path='approve/:approvalGuid' element={<ApprovePage />} />
      <Route path='reset/:approvalGuid' element={<ResetPage />} />
      <Route path='email-verification' element={<EmailVerification />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
